/**
 * Coaching module navigation helpers.
 *
 * Uses wouter's navigate (via use-browser-location) to set the hash in the
 * `#/<page>` format that the app's hashLocation hook expects.
 * Backbone.history still picks up the hashchange event for content-view switching.
 */
import { navigate } from "wouter/use-browser-location";

/**
 * Navigate to a specific coaching session
 */
export const navigateToCoachingSession = (sessionId: string): void => {
    navigate(`#/-/coaching/${ sessionId }`);
};

/**
 * Navigate to the coaching module main page
 */
export const navigateToCoaching = (): void => {
    navigate("#/-/coaching");
};

/**
 * Navigate to the session completed confirmation page
 */
export const navigateToCoachingCompleted = (sessionId: string): void => {
    navigate(`#/-/coaching/completed/${ sessionId }`);
};
